import { render, staticRenderFns } from "./edit-my-information.vue?vue&type=template&id=e315eca0&"
import script from "./edit-my-information.vue?vue&type=script&lang=js&"
export * from "./edit-my-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports